<section class="title-and-ctas">
  <h1
    class="visible-xs visible-sm hidden-md hidden-lg"
    [innerHTML]="titleMobile | safeHtml"
    (click)="enterFullscreen($event)"></h1>
  <section class="ctas visible-xs visible-sm hidden-md hidden-lg">
    <a
      class="cta play-full-video"
      href="#"
      name="&lid={{ctasMobile[0]['analyticsLinkId']}}"
      title="{{ctasMobile[0]['alt']}}"
      aria-hidden="false"
      (click)="enterFullscreen($event)">
      {{ctasMobile[0]['title']}}
      <span class="icon" aria-hidden="true"></span>
    </a>
    <a
      class="cta details-cta"
      href="{{ctasMobile[1]['ctaURL'] | absTrimmer:true:true}}"
      name="&lid={{ctasMobile[1]['analyticsLinkId']}}"
      title="{{ctasMobile[1]['alt']}}"
      aria-hidden="false">
      {{ctasMobile[1]['title']}}
      <span class="icon" aria-hidden="true"></span>
    </a>
  </section>
  <h1
    class="hidden-xs hidden-sm visible-md visible-lg"
    [innerHTML]="titleDesktop | safeHtml"
    (click)="enterFullscreen($event)"></h1>
  <section class="ctas hidden-xs hidden-sm visible-md visible-lg">
    <a
      class="cta play-full-video"
      href="#"
      name="&lid={{ctasDesktop[0]['analyticsLinkId']}}"
      title="{{ctasDesktop[0]['alt']}}"
      aria-hidden="false"
      (click)="enterFullscreen($event)">
      {{ctasDesktop[0]['title']}}
      <span class="icon" aria-hidden="true"></span>
    </a>
    <a
      class="cta details-cta"
      href="{{ctasDesktop[1]['ctaURL'] | absTrimmer:true:true}}"
      name="&lid={{ctasDesktop[1]['analyticsLinkId']}}"
      title="{{ctasDesktop[1]['alt']}}"
      aria-hidden="false">
      {{ctasDesktop[1]['title']}}
      <span class="icon" aria-hidden="true"></span>
    </a>
  </section>
</section>
<a
  class="cta-fullscreen"
  href="{{ctasDesktop[1]['ctaURL'] | absTrimmer:true:true}}"
  name="&lid={{ctasDesktop[1]['analyticsLinkIdFullscreen']}}"
  title="{{ctasDesktop[1]['alt']}}"
  aria-hidden="false">
  {{ctasDesktop[1]['title']}}
  <span class="icon" aria-hidden="true"></span>
</a>
<iframe class="me-iframe" [src]="src" frameborder="0" scrolling="no"></iframe>